module.exports = __webpack_public_path__ + "img/advertisement-pool.3505697f.svg";